<div class="dialog-header">
  <h2 mat-dialog-title>Отклик на квоту</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <!-- Simple step indicator -->
  <div class="step-indicator">
    <span [class.active]="currentStep() === 0">1. Компания</span>
    <span [class.active]="currentStep() === 1">2. Данные</span>
    <span [class.active]="currentStep() === 2">3. Заявка</span>
  </div>

  @if (loadingData()) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Загрузка данных...</p>
  </div>
  } @else {
  <!-- Step 1: Company Info -->
  @if (currentStep() === 0) {
  <form [formGroup]="step1Form" class="form-content">
    <h3>Информация о компании</h3>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>ИНН</mat-label>
        <input matInput formControlName="inn">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Рег. номер</mat-label>
        <input matInput formControlName="registrationNumber">
      </mat-form-field>
    </div>

    @if (supplierProfile()?.companyName) {
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Название компании</mat-label>
      <input matInput formControlName="companyName">
    </mat-form-field>
    }

    @if (supplierProfile()?.okpo) {
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ОКПО</mat-label>
      <input matInput formControlName="okpo">
    </mat-form-field>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Дата регистрации</mat-label>
      <input matInput [matDatepicker]="regDatePicker" formControlName="registrationDate" (click)="regDatePicker.open()">
      <mat-datepicker-toggle matIconSuffix [for]="regDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #regDatePicker></mat-datepicker>
    </mat-form-field>
  </form>
  }

  <!-- Step 2: Personal Data -->
  @if (currentStep() === 1) {
  <form [formGroup]="step2Form" class="form-content">
    <h3>Личные данные</h3>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>ФИО</mat-label>
        <input matInput formControlName="name">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>ПИН</mat-label>
        <input matInput formControlName="pin">
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Номер паспорта</mat-label>
      <input matInput formControlName="passportNumber">
    </mat-form-field>

    <h3>Контакты</h3>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Телефон</mat-label>
        <input matInput formControlName="phoneNumber">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email">
      </mat-form-field>
    </div>
  </form>
  }

  <!-- Step 3: Application -->
  @if (currentStep() === 2) {
  <form [formGroup]="step3Form" class="form-content">
    <!-- Proxy Document -->
    <h3>Доверенность с контрагентом</h3>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Номер</mat-label>
        <input matInput formControlName="proxyDocumentNumber">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Дата</mat-label>
        <input matInput [matDatepicker]="proxyDatePicker" formControlName="proxyDocumentDate"
          (click)="proxyDatePicker.open()">
        <mat-datepicker-toggle matIconSuffix [for]="proxyDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #proxyDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Acting As (only for LLC) -->
    @if (showActingAsFields()) {
    <h3>Действует как</h3>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Роль</mat-label>
      <mat-select formControlName="actingAs">
        <mat-option value="AGENT">Агент</mat-option>
        <mat-option value="DIRECTOR">Директор</mat-option>
      </mat-select>
    </mat-form-field>

    @if (!isDirector()) {
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Дата контракта</mat-label>
        <input matInput [matDatepicker]="contractDatePicker" formControlName="contractDate"
          (click)="contractDatePicker.open()">
        <mat-datepicker-toggle matIconSuffix [for]="contractDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #contractDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Номер контракта</mat-label>
        <input matInput formControlName="contractNumber">
      </mat-form-field>
    </div>
    }
    }

    <!-- Veterinary Document -->
    <h3>Ветеринарный документ</h3>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Дата выдачи</mat-label>
        <input matInput [matDatepicker]="vetDatePicker" formControlName="vetServiceIssueDate"
          (click)="vetDatePicker.open()">
        <mat-datepicker-toggle matIconSuffix [for]="vetDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #vetDatePicker></mat-datepicker>
        @if (step3Form.get('vetServiceIssueDate')?.hasError('required') &&
        step3Form.get('vetServiceIssueDate')?.touched) {
        <mat-error>Обязательно</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Номер</mat-label>
        <input matInput formControlName="vetServiceIssueNumber">
        @if (step3Form.get('vetServiceIssueNumber')?.hasError('required') &&
        step3Form.get('vetServiceIssueNumber')?.touched) {
        <mat-error>Обязательно</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Quota & Volume -->
    @if (quota()) {
    <h3>Квота: {{ quota()!.meatType.nameRu }}</h3>
    <div class="quota-stats">
      <div><strong>Лимит:</strong> {{ quota()!.totalLimitVolume | kgToTons }}</div>
      <div><strong>Распределено:</strong> {{ quota()!.allocatedVolume | kgToTons }}</div>
      <div><strong>Остаток:</strong> {{ quota()!.remainderVolume | kgToTons }}</div>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Запрашиваемый объем (тонн)</mat-label>
      <input matInput type="number" formControlName="requestedVolume" (input)="onVolumeChange($event)" min="0"
        step="0.1">
      @if (step3Form.get('requestedVolume')?.hasError('required') && step3Form.get('requestedVolume')?.touched) {
      <mat-error>Обязательно</mat-error>
      }
      @if (volumeWarning()) {
      <mat-hint class="warning">{{ volumeWarning() }}</mat-hint>
      }
    </mat-form-field>
    }

    <!-- Consent -->
    <mat-checkbox formControlName="consentToDataProcessing" color="primary">
      <span class="required">*</span> Согласен на обработку данных
    </mat-checkbox>
    @if (step3Form.get('consentToDataProcessing')?.hasError('required') &&
    step3Form.get('consentToDataProcessing')?.touched) {
    <mat-error>Необходимо согласие</mat-error>
    }
  </form>
  }

  <!-- Error -->
  @if (errorMessage()) {
  <div class="error-message">{{ errorMessage() }}</div>
  }
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <div class="actions-left">
    @if (currentStep() > 0) {
    <button mat-button (click)="prev()">
      <mat-icon>arrow_back</mat-icon>
      Назад
    </button>
    }
  </div>

  <div class="actions-right">
    @if (currentStep() < 2) { <button mat-raised-button style="background-color: #4caf50; color: white;"
      (click)="next()">
      Далее
      <mat-icon>arrow_forward</mat-icon>
      </button>
      }

      @if (currentStep() === 2) {
      <button mat-raised-button style="background-color: #4caf50; color: white;" (click)="handleSubmit()"
        [disabled]="loading()">
        @if (loading()) {
        <mat-spinner diameter="20"></mat-spinner>
        } @else {
        Отправить
        }
      </button>
      }
  </div>
</mat-dialog-actions>